import { render, staticRenderFns } from "./SetStorageStatus.vue?vue&type=template&id=d5d18f24&"
import script from "./SetStorageStatus.vue?vue&type=script&lang=js&"
export * from "./SetStorageStatus.vue?vue&type=script&lang=js&"
import style0 from "./SetStorageStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VContainer,VSelect,VSlideGroup,VSlideItem})
